/**
 * ============================================================================
 * 3-LEVEL MEGA MENU INTERACTIVITY
 * ============================================================================
 *
 * Functionaliteit:
 * - Hover over Level 2 items (Vibrators, Dildos, etc.) toont Level 3 subcategorieën
 * - Smooth transitions tussen Level 3 content
 * - Active state management
 *
 */

class MegaMenu {
  constructor() {
    this.init();

    // Set position after a small delay to ensure all CSS is loaded
    setTimeout(() => {
      this.setMegaMenuPosition();
    }, 100);

    // Update position on resize
    window.addEventListener('resize', () => {
      this.setMegaMenuPosition();
    });

    // Update position on scroll (if header is sticky)
    window.addEventListener('scroll', () => {
      this.setMegaMenuPosition();
    });
  }

  init() {
    // Find all mega menus on the page
    const megaMenus = document.querySelectorAll('.mega-menu-3level');

    megaMenus.forEach(menu => {
      this.setupMenu(menu);
    });
  }

  setMegaMenuPosition() {
    // Calculate the position where mega menu should appear (below header-bottom)
    const headerBottom = document.querySelector('.header-bottom');
    if (headerBottom) {
      const headerBottomRect = headerBottom.getBoundingClientRect();
      const topPosition = headerBottomRect.bottom;

      // Set CSS variable for mega menu top position (no need for scrollY with fixed positioning)
      document.documentElement.style.setProperty('--mega-menu-top', `${topPosition}px`);
    }
  }

  setupMenu(menu) {
    const level2Items = menu.querySelectorAll('.mega-menu-level2-item');
    const level3Contents = menu.querySelectorAll('.mega-menu-level3-content');

    level2Items.forEach((item, index) => {
      // Mouse enter - show corresponding Level 3 content
      item.addEventListener('mouseenter', () => {
        this.showLevel3Content(level2Items, level3Contents, index);
      });

      // Click on link should still work
      const link = item.querySelector('.mega-menu-level2-link');
      if (link) {
        link.addEventListener('click', (e) => {
          // Only prevent default if there are subcategories
          const hasSubcategories = item.querySelector('.chevron');
          if (hasSubcategories) {
            // Let the link work normally - user can click to go to category page
            // The hover will show subcategories
          }
        });
      }
    });
  }

  showLevel3Content(level2Items, level3Contents, activeIndex) {
    // Remove active class from all Level 2 items
    level2Items.forEach(item => {
      item.classList.remove('active');
    });

    // Remove active class from all Level 3 contents
    level3Contents.forEach(content => {
      content.classList.remove('active');
    });

    // Add active class to the hovered Level 2 item
    if (level2Items[activeIndex]) {
      level2Items[activeIndex].classList.add('active');
    }

    // Show corresponding Level 3 content
    if (level3Contents[activeIndex]) {
      level3Contents[activeIndex].classList.add('active');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenu();
  });
} else {
  new MegaMenu();
}
